export default {"src":"/_next/static/media/supercell-logo-white.ad1dad43.svg","height":40,"width":49};